import { Outlet } from 'react-router-dom';

import ProjectScreenerOverlay from '../../components/ProjectScreenerOverlay';
import { usePermissions } from '../../utils/hooks/usePermissions';

import { ProjectScreenerStub } from './ProjectScreenerStub';

const ProjectScreenerGuard = () => {
  const { hasPermission } = usePermissions();
  const allowed = hasPermission('dashboard:project_screener');

  if (!allowed) {
    return (
      <>
        <ProjectScreenerStub />
        <ProjectScreenerOverlay />
      </>
    );
  }
  return <Outlet />;
};

export { ProjectScreenerGuard };
